import "core-js/modules/es.array.push.js";
import { showNotify } from 'vant';
import SearchSelect from '@/components/SearchSelect';
import { searchSupplyPay, saveSupplyPay, saveApproval, getSupplyPayDataList, getSettlementAccountList, saveMobilePayment } from '@/api/global';
import { ensureAuth } from '@/utils/wxauth';
export default {
  name: 'searchSupplyPayIndex',
  components: {
    SearchSelect
  },
  props: {},
  inject: ['reload'],
  data() {
    // 这里存放数据
    return {
      active: 0,
      type: 0,
      types: 0,
      checked: [],
      // 改为数组类型存储选中项
      showdate: false,
      showsearch: false,
      showBottom: false,
      showPicker: false,
      showSupplierSelect: false,
      showCustomerSelect: false,
      showSupplierAccountSelect: false,
      showCustomerAccountSelect: false,
      showProjectSelect: false,
      projectId: '',
      // 当前选中工程的 value
      supplierId: '',
      // 当前选中供应商的 value，用于回显打勾
      customerId: '',
      // 当前选中客户的 value
      supplierAccountId: '',
      // 供应商账户 id（settlement_account_list.id）
      customerAccountId: '',
      // 客户账户 id
      accountText: {
        supplier: '',
        customer: ''
      },
      // 账户展示文案（性质+银行+账号）
      pickerField: '',
      // 当前正在用 picker 编辑的 datainfo 字段
      selectIds: {},
      // 各字段选中的 value（名称 -> id），提交时如需要可直接取用
      show: false,
      date: '请选择日期',
      searchdate: '请选择日期',
      minDate: new Date(2023, 0, 1),
      // 最早可选日期
      maxDate: new Date(),
      // 当前日期作为最晚可选日期
      collectionlist: [],
      page: 0,
      loading: false,
      finished: false,
      finishedtext: '没有更多了',
      datainfo: {
        PaymentDate: null,
        PaymentBussTypeName: '供应付款',
        PaymentTermsName: '转账',
        SettlementName: null,
        AccountType: null,
        CompanyName: null,
        ProjectShortName: null,
        TeamName: null,
        Amount: null,
        AttnName: null,
        purpose: '货款',
        Memo: null
      },
      collectionData: [],
      wanglaiData: [],
      companylist: [],
      supplierlist: [],
      projectlist: [],
      customerlist: [],
      teamlist: [],
      sellerlist: [],
      PaymentTermslist: [],
      PaymentBussTypelist: [],
      AccountTypelist: [],
      supplierData: [],
      projectData: [],
      columns: [{
        text: '杭州',
        value: 'Hangzhou'
      }, {
        text: '宁波',
        value: 'Ningbo'
      }, {
        text: '温州',
        value: 'Wenzhou'
      }, {
        text: '绍兴',
        value: 'Shaoxing'
      }, {
        text: '湖州',
        value: 'Huzhou'
      }],
      permission: false,
      isuser: false
    };
  },
  // 计算属性 类似于data概念
  computed: {
    // 付款类型名称里含「客户」→ 走客户/客户账户；其余（供应付款等）→ 供应商/供应商账户
    isCustomerPay() {
      return String(this.datainfo.PaymentBussTypeName || '').indexOf('退款') > -1;
    },
    isSupplierPay() {
      return !this.isCustomerPay;
    }
  },
  // 监控data中的数据变化
  watch: {
    'datainfo.PaymentBussTypeName'() {
      // 切换付款类型时清掉另一方的已选内容，避免把供应商信息提交进客户付款单（反之亦然）
      if (this.isCustomerPay) this.clearSupplier();else this.clearCustomer();
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.date = this.getDay(0);
    this.searchdate = this.getDay(0);
    this.datainfo.PaymentDate = this.getDay(0);
    // 授权由 ensureAuth 统一处理，内部做了单飞：本页同时发多个请求时，
    // 一次性的 code 也只会被换票一次，不会再出现「不合法的 oauth_code」
    ensureAuth();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.onLoad();
    this.OngetSupplyPayDataList();
  },
  // 方法集合
  methods: {
    onSubmit() {
      if (this.isuser === false) {
        showNotify({
          type: 'danger',
          message: '您没有权限'
        });
        return false;
      }
      ensureAuth().then(auth => {
        if (!auth.ok) {
          showNotify({
            type: 'danger',
            message: auth.message
          });
          this.show = false;
          return;
        }
        saveMobilePayment({
          data: this.datainfo
        }).then(res => {
          if (res.data.status === 'success') {
            showNotify({
              type: 'success',
              message: res.data.message
            });
            this.show = false;
            this.reload();
          } else {
            showNotify({
              type: 'danger',
              message: res.data.message
            });
            this.show = false;
          }
          this.onLoad();
        }).catch(err => {
          console.log('保存失败', err);
          this.show = false;
        });
      });
    },
    applypay() {
      if (this.isuser === false) {
        showNotify({
          type: 'danger',
          message: '您没有权限'
        });
        return false;
      }
      this.showBottom = true;
    },
    // 供应商：打开带搜索的选择器
    openSupplierSelect() {
      if (!this.supplierlist.length) {
        showNotify({
          type: 'danger',
          message: '供应商数据加载中，请稍候'
        });
        return;
      }
      this.showSupplierSelect = true;
    },
    onSupplierConfirm(item) {
      // 换了供应商，之前选的账户要清掉
      if (this.datainfo.SettlementName !== item.text) this.clearSupplierAccount();
      this.datainfo.SettlementName = item.text;
      this.supplierId = item.value;
      this.selectIds.SettlementName = item.value;
      this.showSupplierSelect = false;
    },
    // 客户：打开带搜索的选择器
    openCustomerSelect() {
      if (!this.customerlist.length) {
        showNotify({
          type: 'danger',
          message: '客户数据加载中，请稍候'
        });
        return;
      }
      this.showCustomerSelect = true;
    },
    onCustomerConfirm(item) {
      if (this.datainfo.CustomerName !== item.text) this.clearCustomerAccount();
      this.datainfo.CustomerName = item.text;
      this.customerId = item.value;
      this.selectIds.CustomerName = item.value;
      this.showCustomerSelect = false;
    },
    // 供应商账户：必须选了供应商才能查
    openSupplierAccountSelect() {
      if (!this.datainfo.SettlementName) {
        showNotify({
          type: 'danger',
          message: '请先选择供应商'
        });
        return;
      }
      this.showSupplierAccountSelect = true;
    },
    openCustomerAccountSelect() {
      if (!this.datainfo.CustomerName) {
        showNotify({
          type: 'danger',
          message: '请先选择客户'
        });
        return;
      }
      this.showCustomerAccountSelect = true;
    },
    // 远程搜索结算账户：SearchSelect 会传入 (keyword, page)，需返回数组
    searchAccount(name) {
      return (keyword, page) => {
        return ensureAuth().then(auth => {
          if (!auth.ok) {
            showNotify({
              type: 'danger',
              message: auth.message
            });
            return [];
          }
          return getSettlementAccountList({
            name,
            keyword,
            page,
            per: 30
          }).then(res => {
            if (res.data.status === 'success') return res.data.data;
            showNotify({
              type: 'danger',
              message: res.data.message || '查询账户失败'
            });
            return [];
          });
        }).catch(() => []);
      };
    },
    searchSupplierAccount(keyword, page) {
      return this.searchAccount(this.datainfo.SettlementName)(keyword, page);
    },
    searchCustomerAccount(keyword, page) {
      return this.searchAccount(this.datainfo.CustomerName)(keyword, page);
    },
    onSupplierAccountConfirm(item) {
      this.accountText.supplier = item.text;
      this.supplierAccountId = item.value;
      this.datainfo.AccountType = item.value; // 后端按此 id 回填银行/账号
      // this.datainfo.SettlementBankName = item.raw?.BankName ?? ''
      // this.datainfo.SBankAccount = item.raw?.BankAccount ?? ''
      this.showSupplierAccountSelect = false;
    },
    onCustomerAccountConfirm(item) {
      this.accountText.customer = item.text;
      this.customerAccountId = item.value;
      this.datainfo.CustomerAccountId = item.value;
      this.showCustomerAccountSelect = false;
    },
    clearSupplierAccount() {
      this.accountText.supplier = '';
      this.supplierAccountId = '';
      this.datainfo.AccountType = null;
      // this.datainfo.SettlementBankName = null
      // this.datainfo.SBankAccount = null
    },

    clearSupplier() {
      this.datainfo.SettlementName = null;
      this.supplierId = '';
      this.selectIds.SettlementName = '';
      this.clearSupplierAccount();
    },
    clearCustomer() {
      this.datainfo.CustomerName = null;
      this.customerId = '';
      this.selectIds.CustomerName = '';
      this.clearCustomerAccount();
    },
    clearCustomerAccount() {
      this.accountText.customer = '';
      this.customerAccountId = '';
      this.datainfo.CustomerAccountId = null;
    },
    // 工程：打开带搜索的选择器
    openProjectSelect() {
      if (!this.projectlist.length) {
        showNotify({
          type: 'danger',
          message: '工程数据加载中，请稍候'
        });
        return;
      }
      this.showProjectSelect = true;
    },
    onProjectConfirm(item) {
      this.datainfo.ProjectShortName = item.text;
      this.projectId = item.value;
      this.selectIds.ProjectShortName = item.value;
      this.showProjectSelect = false;
    },
    // 把任意结构的列表统一成 vant-picker 需要的 { text, value }
    normalizeColumns(list) {
      return (list || []).map((row, index) => ({
        text: String(row.text ?? row.name ?? row.Name ?? row.title ?? row.shortName ?? row.ProjectShortName ?? ''),
        value: row.value ?? row.id ?? row.ID ?? index
      }));
    },
    clickPicker(name, type) {
      this.pickerField = name;
      const map = {
        1: this.supplierlist,
        // 供应商
        2: this.AccountTypelist,
        // 供应商账户
        3: this.customerlist,
        // 客户
        4: this.AccountTypelist,
        // 客户账户
        5: this.companylist,
        // 公司
        6: this.sellerlist,
        // 经办人
        7: this.PaymentBussTypelist,
        // 付款类型
        8: this.PaymentTermslist,
        // 支付方式
        92: this.projectlist,
        // 工程
        10: this.teamlist // 业务组
      };

      this.columns = this.normalizeColumns(map[type] || []);
      if (!this.columns.length) {
        showNotify({
          type: 'danger',
          message: '暂无可选项'
        });
        return;
      }
      this.showPicker = true;
    },
    onColumns({
      selectedOptions
    }) {
      this.showPicker = false;
      const opt = selectedOptions && selectedOptions[0];
      if (!opt) return;
      this.datainfo[this.pickerField] = opt.text;
      this.selectIds[this.pickerField] = opt.value;
    },
    formatDate(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    },
    onConfirm(value) {
      this.showdate = false;
      if (this.type === 0) {
        this.date = this.formatDate(value);
      } else if (this.type === 1) {
        this.searchdate = this.formatDate(value);
      } else if (this.type === 3) {
        this.datainfo.PaymentDate = this.formatDate(value);
      }
    },
    OngetSupplyPayDataList() {
      ensureAuth().then(auth => {
        if (!auth.ok) {
          return;
        }
        getSupplyPayDataList().then(res => {
          if (res.data.status === 'success') {
            this.companylist = res.data.data.company;
            this.customerlist = res.data.data.customer;
            this.supplierlist = res.data.data.supplier;
            this.projectlist = res.data.data.project;
            this.teamlist = res.data.data.team;
            this.sellerlist = res.data.data.seller;
            this.PaymentTermslist = res.data.data.PaymentTerms;
            this.PaymentBussTypelist = res.data.data.PaymentBussType;
            this.AccountTypelist = res.data.data.AccountType || [];
          }
        }).catch(err => {
          console.log('保存失败', err);
          this.show = false;
        });
      });
    },
    searchs() {
      if (this.isuser === false) {
        showNotify({
          type: 'danger',
          message: '您没有权限'
        });
        return false;
      }
      this.showsearch = true;
    },
    search() {
      if (this.isuser === false) {
        showNotify({
          type: 'danger',
          message: '您没有权限'
        });
        return false;
      }
      this.show = true;
      this.onLoad();
    },
    selectAll() {
      if (this.permission === false) {
        showNotify({
          type: 'danger',
          message: '您没有权限'
        });
        return false;
      }
      if (this.checked.length === this.collectionlist.filter(item => item.status !== '已提交').length) {
        // 如果已经全选（除已提交外），则取消全选
        this.checked = [];
      } else {
        // 否则，选择所有未提交的项目
        this.checked = this.collectionlist.filter(item => item.status !== '已提交').map(item => item.ids);
      }
    },
    approval() {
      if (this.permission === false) {
        showNotify({
          type: 'danger',
          message: '您没有权限'
        });
        return false;
      }
      if (this.checked.length === 0) {
        showNotify({
          type: 'danger',
          message: '请选择提交内容'
        });
        return false;
      }
      this.show = true;
      ensureAuth().then(auth => {
        if (!auth.ok) {
          showNotify({
            type: 'danger',
            message: auth.message
          });
          this.show = false;
          return;
        }
        saveApproval({
          selectData: this.checked
        }).then(res => {
          if (res.data.status === 'success') {
            showNotify({
              type: 'success',
              message: res.data.message
            });
            this.show = false;
            this.reload();
          } else {
            showNotify({
              type: 'danger',
              message: res.data.message
            });
            this.show = false;
          }
          this.onLoad();
        }).catch(err => {
          console.log('保存失败', err);
          this.show = false;
        });
      });
    },
    onClickRight() {
      if (this.permission === false) {
        showNotify({
          type: 'danger',
          message: '您没有权限'
        });
        return false;
      }
      if (this.checked.length === 0) {
        showNotify({
          type: 'danger',
          message: '请选择提交内容'
        });
        return;
      }
      this.show = true;
      ensureAuth().then(auth => {
        if (!auth.ok) {
          showNotify({
            type: 'danger',
            message: auth.message
          });
          this.show = false;
          return;
        }
        saveSupplyPay({
          selectData: this.checked
        }).then(res => {
          if (res.data.status === 'success') {
            showNotify({
              type: 'success',
              message: res.data.message
            });
            this.show = false;
            this.reload();
          } else {
            showNotify({
              type: 'danger',
              message: res.data.message
            });
            this.show = false;
          }
          this.onLoad();
        }).catch(err => {
          console.log('保存失败', err);
          this.show = false;
        });
      });
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        const _this = this;
        ensureAuth().then(auth => {
          if (!auth.ok) {
            showNotify({
              type: 'danger',
              message: auth.message
            });
            _this.finishedtext = auth.message;
            _this.loading = false;
            _this.finished = true;
            _this.showsearch = false;
            _this.show = false;
            return;
          }
          _this.page++;
          searchSupplyPay({
            startDate: _this.searchdate,
            endDate: _this.searchdate,
            page: _this.page,
            per: 2
          }).then(res => {
            if (res.data.status === 'success') {
              _this.permission = res.data.role.permission;
              _this.datainfo.AttnName = res.data.role.username;
              _this.isuser = res.data.role.isuser;
              if (res.data.page_total >= _this.page) {
                res.data.data.forEach(function (item, index) {
                  _this.collectionlist.push(item);
                });
                _this.showsearch = false;
                _this.loading = false;
                _this.show = false;
              } else {
                _this.showsearch = false;
                _this.finished = true;
                _this.show = false;
              }
            } else {
              showNotify({
                type: 'danger',
                message: res.data.message
              });
              _this.finishedtext = res.data.message;
              _this.loading = false;
              _this.finished = true;
              _this.showsearch = false;
              _this.show = false;
            }
          }).catch(err => {
            console.log('保存失败', err);
            _this.show = false;
          });
        });
      }, 1000);
    },
    getDay(day) {
      const today = new Date();
      const targetdaymilliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
      today.setTime(targetdaymilliseconds);
      const tYear = today.getFullYear();
      let tMonth = today.getMonth();
      let tDate = today.getDate();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      return tYear + '-' + tMonth + '-' + tDate;
    },
    doHandleMonth(month) {
      let m = month;
      if (month.toString().length === 1) {
        m = '0' + month;
      }
      return m;
    }
  }
};